<template>
    <div class="TestpaperList">
        <div class="filters">
            <div class="add">
                <el-button @click="handleAddTestPaper"  type="primary">新建试卷</el-button>
                <el-button type="primary"  @click="handleAddSort">试卷分类</el-button>
            </div>
            <div class="search">
                <el-select v-model="param.status" placeholder="全部状态" class="condition" clearable>
                    <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-input v-model="param.keywordsValue" placeholder="请输入试卷名称关键词" class="condition" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
        </div>
        <div class="panl">
            <div class="left">
                <div class="tree_warp_box">
                    <el-tree :data="classInfoData" node-key="id" :default-expanded-keys="[1, 0]" @node-click="handleNodeClick" :expand-on-click-node="false">
                    <span class="custom-tree-node" slot-scope="{node, data}">
                        <span style="margin-right: 12px;">{{node.label}}</span>
                        <span style="color: #909399;">{{data.datacount}}</span>
                    </span>
                    </el-tree>
                </div>
            </div>
            <div class="right">
                <div class="operate" v-if="multipleSelection.length > 0">
                    <div>已选择<span class="tc-blue">{{multipleSelection.length}}</span>项</div>
                    <div class="btn">
                        <el-button @click="openTransferPop(true)" type="text" size="small">转移</el-button>
                        <span class="separator">|</span>
                        <el-button @click="openCopyPop(true)" type="text" size="small">复制</el-button>
                        <span class="separator">|</span>
                        <el-button @click="delQuestionsClick(2)" type="text" size="small">删除</el-button>
                    </div>
                </div>
                <div class="result-list btn-operate-list">
                    <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" ref="multipleTable">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="name" label="试卷名称" width="300px" class-name="title">
                            <template slot-scope="scope">
                                <div class="paperName">
                                    <!-- <img :src="scope.row.coverurl" alt=""> -->
                                    <div>{{scope.row.name}}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="usecount" label="使用次数" class-name="center"></el-table-column>
                        <el-table-column prop="examcount" label="考试次数" class-name="center"></el-table-column>
                        <el-table-column prop="unreadcount" label="未批阅数" class-name="center"></el-table-column>
                        <el-table-column prop="readcount" label="已批阅数" class-name="center"></el-table-column>
                        <el-table-column prop="status" label="试卷状态" class-name="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.statustext==='待发布'" style="color: #FFA904">{{scope.row.statustext}}</span>
                                <span v-if="scope.row.statustext==='已发布'" style="color: #67C23A">{{scope.row.statustext}}</span>
                                <span v-if="scope.row.statustext==='已删除'" style="color: #909399">{{scope.row.statustext}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="quescount" label="题目数量" class-name="center"></el-table-column>
                        <el-table-column prop="datetime" label="创建时间" width="170" class-name="center"></el-table-column>
                        <el-table-column label="操作" width="240" label-class-name="tr">
                            <template slot-scope="scope">
                                <div class="tr">
                                <span>
                                    <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                                    <span class="separator">|</span>
                                </span>
                                    <span>
                                    <el-button @click="handleTestQuestions(scope.row)" type="text" size="small">试题</el-button>
                                    <span class="separator">|</span>
                                </span>
                                    <span>
                                    <el-button @click="handleMarking(scope.row)" type="text" size="small">批阅</el-button>
                                    <span class="separator">|</span>
                                </span>
                                    <span>
                                    <el-button @click="openTransferPop(false, scope.row)" type="text" size="small">转移</el-button>
                                    <span class="separator">|</span>
                                </span>
                                    <el-dropdown>
                                    <span class="el-dropdown-link">
                                        <el-button type="text" size="small">更多</el-button>
                                    </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item @click.native="openCopyPop(false, scope.row)">复制</el-dropdown-item>
                                            <el-dropdown-item @click.native="handleExportExamPaperQuestion(scope.row)">导出</el-dropdown-item>
                                            <el-dropdown-item v-show="scope.row.status!==3" @click.native="delQuestionsClick(1, scope.row)">删除</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <page :total="totalPage"  @getList="_getList" ref="page"></page>
            </div>
        </div>
        <TransferPop @getClassId="getClassId" ref="transferpop"></TransferPop>
        <CopyPop @getClassId="getClassId" ref="copypop"></CopyPop>
        <NoClassPop ref="noclasspop"></NoClassPop>
    </div>
</template>

<script>
    import TransferPop from 'views/questionbank/components/TransferPop'
    import CopyPop from 'views/questionbank/components/CopyPop'
    import NoClassPop from 'views/questionbank/components/NoClassPop'
    import {getAllHostcatalog} from 'api/questionApi'
    import {getAllExampaperInfo,moveExampaperToCate,copyExampaper,deleteExampaper,exportExamPaperQuestion} from 'api/testPaperApi'
    import Page from 'base/page/page'
    import {mapGetters, mapActions} from 'vuex'
    import {dateFormat} from 'common/js/tools'
    export default {
        name: 'TestpaperList',
        data() {
            return {
                classInfoData: [], //分类列表
                param: {
                    classId:'', //分类id
                    status: '',
                    keywordsValue:'', //题目关键词
                    classname: ''
                },
                multipleSelection: [],
                statusList: [
                    {label:'全部',value:''},
                    {label:'待发布',value:'1'},
                    {label:'已发布',value:'2'},
                    // {label:'已删除',value:'3'},
                ],
                totalPage: 0,
                tableData: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                selectIds: '' //列表所选分类id
            }
        },
        mounted() {
            this._getList();
            this.findAllHostcatalog();
        },
        methods: {
            // 获取列表信息
            _getList() {
                this.setLoading(true);
                let params = {
                    subject: this.param.keywordsValue, // 题目关键词
                    status:this.param.status,
                    // questiontype: this.topicValue, // 试题类型：0或者空 全部 1单选题 2多选题 3不定项选择题 4判断题 5填空题 6问答题
                    // cateid: this.param.classId?this.param.classId:0, // 分类id，可为空
                    cateid: this.param.classId, // 分类id，可为空
                    page: this.page.page,
                    pagesize:this.page.pageSize,
                };
                getAllExampaperInfo({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false);
                        this.tableData = data.data.content;
                        this.totalPage = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
            // 获取题库分类列表，按elementui树结构返回，代码需支持无限级，使用递归算法
            findAllHostcatalog() {
                this.setLoading(true);
                let params = {
                    catetype: 2,
                    showdefault: 1
                };
                getAllHostcatalog({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false);
                        this.classInfoData = [data.data]
                    },
                    error: data => {
                        console.log('error：', data);
                        this.setLoading(false)
                    }
                })
            },
            handleNodeClick(data) {
                console.log(data);
                this.totalPage = 0;
                this.param.classId = data.id;
                this.param.classname = data.label;
                if(data.id === 1) {
                    this.param.classId = ''
                }
                this.handleQuery()
            },
            handleQuery() {
                this.$refs.page.handleSizeChange(1)
            },
            // 获取分类菜单id
            getClassId(id, type) {
                if(type === '复制试卷') {
                    this.copyQuestionFn(id)
                } else if(type === '转移试卷') {
                    this.moveQuestionToCateFn(id)
                }
            },
            // 打开复制题目弹窗
            openCopyPop(batch, item) {
                if(this.classInfoData[0].children.length > 1) {
                    if(batch) {
                        let ids = [];
                        for (let i = 0; i < this.multipleSelection.length; i++) {
                            ids.push(this.multipleSelection[i].innerid)
                        }
                        ids = ids.join(',');
                        this.selectIds = ids
                    } else {
                        this.selectIds = item.innerid
                    }
                    this.$refs.copypop.openDialog(this.classInfoData, '复制试卷')
                } else {
                    this.openNoClassPop()
                }
            },
            // 导出试卷
            handleExportExamPaperQuestion(item) {
                this.setLoading(true)
                var params = {
                    examinnerid: item.innerid
                }
                exportExamPaperQuestion({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                        let fileName = item.name + '试卷' + dateFormat(new Date()) + '.xls'
                        if (window.navigator.msSaveOrOpenBlob) {
                            navigator.msSaveBlob(blob, fileName)
                        } else {
                            var link = document.createElement('a')
                            link.href = window.URL.createObjectURL(blob)
                            link.download = fileName
                            link.click() // 释放内存
                            window.URL.revokeObjectURL(link.href)
                        }
                        // this.$message.success('导出成功')
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }   
                })
            },
            // 打开转移题目弹窗
            openTransferPop(batch, item) {
                if(this.classInfoData[0].children.length > 1) {
                    if(batch) {
                        let ids = [];
                        for (let i = 0; i < this.multipleSelection.length; i++) {
                            ids.push(this.multipleSelection[i].innerid)
                        }
                        ids = ids.join(',');
                        this.selectIds = ids
                    } else {
                        this.selectIds = item.innerid
                    }
                    this.$refs.copypop.openDialog(this.classInfoData, '转移试卷')
                } else {
                    this.openNoClassPop()
                }
            },
            // 打开无分类时弹窗
            openNoClassPop() {
                this.$refs.noclasspop.openDialog(this.classInfoData)
            },
            // 复制试卷
            copyQuestionFn(classid) {
                this.setLoading(true);
                let params = {
                    innerids: this.selectIds,
                    cateid: classid
                };
                console.log(params);
                copyExampaper({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false);
                        this.$refs.copypop.closeDialog();
                        this._getList();
                        this.findAllHostcatalog();
                    },
                    error: data => {
                        this.setLoading(false);
                        console.log('error：', data);
                    }
                })
            },
            // 转移试卷
            moveQuestionToCateFn(classid) {
                this.setLoading(true);
                let params = {
                    innerids: this.selectIds,
                    cateid: classid
                };
                moveExampaperToCate({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        this.$refs.copypop.closeDialog()
                        this._getList();
                        this.findAllHostcatalog();
                    },
                    error: data => {
                        console.log('error：', data)
                        this.setLoading(false)
                    }
                })
            },
            // 删除试卷   type :   1、删除单个试卷  2、批量删除试卷
            delQuestionsClick(type, val) {
                this.$confirm('是否确认删除该试卷？', '删除试卷', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.setLoading(true);
                    let params = {
                        innerids: '',
                    };
                    if(type === 1) {
                        // 删除单个试卷
                        params.innerids = val.innerid
                    } else {
                        // 批量删除试卷
                        let delIds = [];
                        for (let i = 0; i < this.multipleSelection.length; i++) {
                            delIds.push(this.multipleSelection[i].innerid)
                        }
                        delIds = delIds.join(',');
                        params.innerids = delIds
                    }
                    deleteExampaper({
                        data: Object.assign({}, params),
                        success: data => {
                            this.setLoading(false);
                            this.$message.success('删除成功！');
                            let page = {};
                            if(type === 1) {
                                if(this.tableData.length === 1) {
                                    page = {page: this.page.page - 1, pageSize: 10};
                                    if(page.page === 0) {
                                        page.page = 1
                                    }
                                    this.setPage(page)
                                }
                            } else {
                                if(this.multipleSelection.length === this.tableData.length) {
                                    page = {page: this.page.page - 1, pageSize: 10};
                                    if(page.page === 0) {
                                        page.page = 1
                                    }
                                    this.setPage(page)
                                }
                            }
                            this._getList();
                        },
                        error: data => {
                            console.log('error：', data);
                            this.setLoading(false);
                            this.$message.error(data.msg)
                        }
                    })
                })
            },
            handleAddSort() { //分类管理
                this.$router.push({name: 'QuestionbankType',query: {catetype: 2}})
            },
            handleAddTestPaper() { //跳转至新增试卷
                this.$router.push({name: 'TestpaperEdit',query: {type: 'add', classId: this.param.classId, classname: this.param.classname}})
            },
            handleEdit(row) { //跳转至编辑试卷
                this.$router.push({name: 'TestpaperEdit', query: {id: row.innerid,type:'edit'}})
            },
            handleMarking(row) {
                this.$router.push({name: 'TestpaperMarking',query: {id: row.innerid}})
            },
            // 跳转至试题
            handleTestQuestions(row){
                this.$router.push({name: 'TestpaperQuesEdit',query: {id: row.innerid}})
            },
            ...mapActions([
                'setLoading',
                'setParams',
                'setPage'
            ])
        },
        filters: {},
        watch: {},
        computed: {
            ...mapGetters([
                'page',
                'permission',
                'shop'
            ])
        },
        components: {
            Page,TransferPop,CopyPop,NoClassPop
        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .TestpaperList {
        .panl {
            display: flex;
            .left {
                width: 300px;
                min-width: 300px;
                max-width: 300px;
                flex: 0 0 auto;
                margin-right: 30px;
                margin-left: -20px;
                .tree_warp_box {
                    overflow: auto;
                    height: calc(100vh - 200px);
                    box-sizing: border-box;
                    border-top: 1px solid #e5e5e5;
                    border-right: 1px solid #e5e5e5;
                    .el-tree-node__content {
                        height: 40px;
                    }
                    .el-tree .el-tree-node.is-current > .el-tree-node__content {
                        background-color: #FAFAFA;
                        color: #409EFF;
                    }
                }
                .tree_warp_box::-webkit-scrollbar {
                    width: 6px;
                }
                .tree_warp_box::-webkit-scrollbar-thumb {
                    border-radius: 4px;
                    background:rgba(229,229,229,1);
                }
                .tree_warp_box::-webkit-scrollbar-track {
                    border-radius: 4px;
                    background: #fff;
                }
            }
            .right {
                overflow: hidden;
                flex-grow: 1;
                .operate {
                    height: 35px;
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    color: #409EFF;
                    background: #E6F1FC;
                    border: 1px solid #409EFF;
                    padding: 0 15px;
                    margin-bottom: 20px;
                    .btn {
                        margin-left: 30px;
                        .el-button, .el-button--mini {
                            min-width: auto;
                            padding: 0 10px;
                            font-size: 14px;
                        }
                    }
                }
                .paperName{
                    display: flex;
                    align-items: center;
                    img{
                        width: 106px;
                        min-width: 106px;
                        height: 60px;
                        display: inline-block;
                        margin-right: 10px;
                    }
                }
            }
        }
    }
    .result-list{
        max-height: calc(100vh - 250px);
        overflow: auto;
        /*position: relative;*/
        /*height: 100%;*/
        /*.el-table{*/
            /*height: 100%;*/
        /*}*/
        /*.el-table--scrollable-x .el-table__body-wrapper{*/
            /*overflow-x: scroll;*/
            /*position: absolute;*/
            /*bottom: 0;*/
            /*height: calc(100vh - 250px);*/
        /*}*/
        /*.el-table thead{*/
            /*position: absolute;*/
            /*top: 0;*/
            /*height: 45px;*/
        /*}*/
        .center {
            text-align: center;
        }
        .el-button+.el-button{
            margin-right: 20px;
        }
    }
    .el-tree-node__content{
        height: 40px;
    }
    .el-button+.el-button{
        margin-left: 20px;
    }
</style>
